exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.confirm-modal .modal-dialog {\n  max-width: 500px;\n}\n.confirm-modal .modal-header {\n  background-color: #fff !important;\n  color: #222c3c !important;\n}\n.confirm-modal .modal-header .close {\n    display: none;\n}\n.confirm-modal .modal-body {\n  height: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2a70c548","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ModalConfirm.vue
// module id = 1553
// module chunks = 0